import React from 'react';
import { Link } from 'react-router-dom';
import { FaNewspaper, FaBullhorn, FaGavel, FaClipboardList, FaCalendarAlt, FaImages, FaVideo } from 'react-icons/fa';

const QuickMenu = () => {
  const menuItems = [
    { icon: <FaNewspaper />, text: 'Haberler', link: '/haberler' },
    { icon: <FaBullhorn />, text: 'Güncel Duyurular', link: '/duyurular' },
    { icon: <FaGavel />, text: 'Güncel İhaleler', link: '/ihaleler' },
    { icon: <FaClipboardList />, text: 'Güncel İlanlar', link: '/ilanlar' },
    { icon: <FaCalendarAlt />, text: 'Etkinlikler', link: '/etkinlikler' },
    // { icon: <FaImages />, text: 'Fotoğraf Galerisi', link: '/fotograf-galerisi' },
    // { icon: <FaVideo />, text: 'Video Galeri', link: '/video-galeri' },
  ];

  return (
    <div className="col-lg-2 col-md-5 z-index-9 p-0">
 <div className="quick-menu">
      <div className="quick-menu-container">
        <div className="quick-menu-title">
          Hızlı Menü
        </div>
        <ul className="quick-menu-list">
          {menuItems.map((item, index) => (
            <li key={index} className="quick-menu-item">
              <Link to={item.link} className="quick-menu-link">
                <span className="quick-menu-icon">{item.icon}</span>
                <span className="quick-menu-text">{item.text}</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
    </div>
   
  );
};

export default QuickMenu;
